import React, { useCallback, useEffect, useState } from 'react';
import { message, Input, Icon, Modal, Button } from 'antd';
import {
  UserDetailHeadingCover,
  LineSeparator,
  InputContainer, InputLabel,
} from './styles';
import { dateDiffInDays } from '../../utils/javascript';
import { ModalBody, ModalContainer } from '../../components/Modals/styles';
import { activateLicense } from '../../utils/services/authAPI';
import { licenseDetails as licenseInfo } from '../../utils/services/onPremAPI';
import Loader from '../../components/Loader';
import { LoginContainer } from '../../components/Modals/styles';
import { withTranslation } from 'react-i18next';
import { MANAGE_LICENSE_SETTINGS as trans } from './TranslationValues';
import { API_ERROR_MESSAGES } from '../../utils/translationValues';
import { ERROR } from '../../utils/constants/apiStatusCodeMap';

const NAMESPACE = ['MANAGE_LICENSE_SETTINGS'];
const LicenseSettings = props => {
  const {t} = props;
  const [loading, setLoading] = useState(true);
  const [licenseDetails, setLicenseDetails] = useState(null);
  const [ subscriptionKey, setSubscriptionKey ] = useState(null);
  const [enterLicense, setEnterLicense] = useState(false);
  const [renewingLicense, setRenewingLicense] = useState(false);
  const [newLicenseKey, setNewLicenseKey] = useState('');

  const checkLicense = useCallback(async () => {
    const response = await licenseInfo();
    setLoading(false);
    if (response) {
      response.licenseExpiryDate = new Date(response.licenseExpiryDate);
    }
    setLicenseDetails(response);
  }, []);

  useEffect(() => {
    checkLicense();    
  }, [checkLicense]);

  const openLicenseModal = useCallback(() => {
    setEnterLicense(true);
  }, []);

  const renewLicense = useCallback(async () => {
    setRenewingLicense(true);
    console.log({ newLicenseKey });
    const response = await activateLicense(newLicenseKey);
    if (response.errors.length === 0) {
      message.success(t(trans.VALID_NEW_ACTIVATION_KEY_SUCCESS_MESSAGE.key,trans.VALID_NEW_ACTIVATION_KEY_SUCCESS_MESSAGE.value));
    } else {
      let errorMessage = `${t(trans.INVALID_NEW_ACTIVATION_KEY_ERROR_MESSAGE.key,trans.INVALID_NEW_ACTIVATION_KEY_ERROR_MESSAGE.value)} `;
      if (response.errors[0].code === 106) {
        errorMessage += t(`API_ERROR_MESSAGES:${API_ERROR_MESSAGES[ERROR[106]].key}`, API_ERROR_MESSAGES[ERROR[106]].value);
      } else if (response.errors[0].code === 107) {
        errorMessage += t(`API_ERROR_MESSAGES:${API_ERROR_MESSAGES[ERROR[107]].key}`, API_ERROR_MESSAGES[ERROR[107]].value);
      } else if (response.errors[0].code === 108) {
        errorMessage += t(`API_ERROR_MESSAGES:${API_ERROR_MESSAGES[ERROR[108]].key}`, API_ERROR_MESSAGES[ERROR[108]].value);
      }
      message.error(errorMessage);
    }
    setRenewingLicense(false);
  }, [newLicenseKey]);

  const today = new Date();
  const diff = licenseDetails?.licenseExpiryDate ? dateDiffInDays(licenseDetails?.licenseExpiryDate, today) : 0;

  return (
    <>
   {loading ? (
        <LoginContainer>
          <Loader />
        </LoginContainer>
      ) : (
        <>
      <UserDetailHeadingCover separator>
        <div>
        <h5>{t(trans.MANAGE_LICENSE_SETTINGS_TITLE.key,trans.MANAGE_LICENSE_SETTINGS_TITLE.value)}</h5>
        </div>
      </UserDetailHeadingCover>
      <LineSeparator />
      <InputContainer>
      <InputLabel>{t(trans.MANAGE_LICENSE_ACTIVATION_KEY_LABEL.key,trans.MANAGE_LICENSE_ACTIVATION_KEY_LABEL.value)}</InputLabel>
        <Input
          name="licenseKey"
          size="large"
          readOnly={true}
          value={licenseDetails?.licenseKey}
          addonAfter={<Icon type={"edit"} onClick={openLicenseModal} />}
        />
      </InputContainer>
      {/* <InputContainer>
      <InputLabel>{t(trans.MANAGE_LICENSE_SUBSCRIPTION_KEY_LABEL.key,trans.MANAGE_LICENSE_SUBSCRIPTION_KEY_LABEL.value)}</InputLabel>
        <Input
          name="licenseKey"
          size="large"
          readOnly={true}
          value={subscriptionKey}
          addonAfter={<Icon type={"copy"} onClick={copySubscriptionKey}/>}
        />
      </InputContainer> */}
      <InputContainer>
      <InputLabel>{t(trans.LICENSE_EXPIRY_DATE_LABEL.key,trans.LICENSE_EXPIRY_DATE_LABEL.value)}</InputLabel>
        <Input
          name="licenseKey"
          size="large"
          readOnly={true}
          value={licenseDetails?.licenseExpiryDate?.toDateString()}
          addonAfter={<div style={{ color: diff >= 0 ? 'red' : diff > -5 ? 'orange' : '#333'}}> {diff > 0 ? t('license.expired')
          : diff === 0 ? t(trans.LICENSE_EXPIRATION_TODAY_LABEL.key,trans.LICENSE_EXPIRATION_TODAY_LABEL.value
            ) : `${Math.abs(diff)} ${t(trans.LICENSE_EXPIRATION_DAYS_TO_GO_LABEL.key,trans.LICENSE_EXPIRATION_DAYS_TO_GO_LABEL.value
                  )}`} </div>}
        />
      </InputContainer>
      {/* {licenseDetails?.features?.includes(TRANSACTIONAL_MODULE) && (<InputContainer>
        <InputLabel>
          <ModulesContainer style={{ marginLeft: 0 }}>
          <div> {t(trans.LICENSE_TRANSACTIONAL_NODES_ACTIVATED_LABEL.key,trans.LICENSE_TRANSACTIONAL_NODES_ACTIVATED_LABEL.value)} </div>
            <div> {`${licenseDetails?.totalActivations} / ${licenseDetails?.allowedActivations}`} </div>
          </ModulesContainer>
        </InputLabel>
      </InputContainer>
      <InputContainer>
      <InputLabel>{t(trans.MANAGE_LICENSE_SETTINGS_ENABLED_MODULES_LABEL.key,trans.MANAGE_LICENSE_SETTINGS_ENABLED_MODULES_LABEL.value)}</InputLabel>
        {MODULES.map((data, index) => {
          return (
            <ModulesContainer key={index}>
              <div>
                <p className={"moduleName"}> {t(data.labelTransKey)} </p>
                <p> {t(data.descTransKey)} </p>
              </div>
              <div>
                {licenseDetails?.features?.includes(data.name)
                  ? <Icon type={'check-circle'} style={{ color: 'green' }} />
                  : <Icon type={'close-circle'} style={{ color: 'red' }} />}
              </div>
            </ModulesContainer>
          );
        })}
      </InputContainer> */}
      </>
      )
      }
      <Modal
        title={t(trans.LICENSE_ACTIVATION_KEY_COLLECTION_MODAL_TITLE.key,trans.LICENSE_ACTIVATION_KEY_COLLECTION_MODAL_TITLE.value)}
        centered
        maskClosable={false}
        visible={enterLicense}
        width="625px"
        onCancel={() => { setEnterLicense(false); }}
        footer={false}
        className="warning-modal"
      >
        <ModalBody>
          <ModalContainer>
            <InputContainer full={true}>
              <Input
                name="newLicenseKey"
                size="large"
                autoComplete={"new-password"}
                onChange={(e) => {
                  setNewLicenseKey(e.target.value);
                }}
              />
              <div className="form_btn">
                <Button
                  key="submit"
                  type="primary"
                  disabled={newLicenseKey === ''}
                  loading={renewingLicense}
                  onClick={renewLicense}
                >
                  {renewingLicense ? t(trans.RENEWING_ACTIVATION_KEY_BUTTON.key, trans.RENEWING_ACTIVATION_KEY_BUTTON.value
                    ) : t(trans.RENEW_ACTIVATION_KEY_BUTTON.key,trans.RENEW_ACTIVATION_KEY_BUTTON.value)}
                </Button>
              </div>
            </InputContainer>
          </ModalContainer>
        </ModalBody>
      </Modal>
    </>
  );
};
export default withTranslation(NAMESPACE)(LicenseSettings);
